import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          Yes: 'Yes',
          No: 'No',
          NavBar: {
            VionHR: 'VionHR',
            home: 'Home',
            login: 'Login',
            logout: 'Logout',
            mydays: 'My Days',
            mydeparmant: 'My Department',
            approvals: 'Approvals',
            companymanagement: 'Company Management',
            companyregistration: 'Company Registration',
            message:
              'Your account email has not been verified. Please check your email address and confirm it.',
            resendLink: 'Click here to resend the verification email.',
            myDocs: 'My Documents',
          },
          Home: {
            welcomeBack: 'Welcome back!',
            pleaseLogIn: 'Please log in to view your profile.',
            loading: 'Loading user data...',
          },
          Login: {
            signIn: 'Sign In',
            signInWithEmail: 'Sign In with Email',
            forgotPassword: 'Forgot Password',
            resetPassword: 'Enter Password',
            passwordlessSignIn: 'Sign In with Email',
            sendSignInLink: 'Send Sign In Link',
            backToSignIn: 'Back to Sign In',
            Confirm: 'Confirm',
            ConfirmYourEmail: 'Confirm Your Email',
            Email: 'Email',
            EnterYourEmailAddress: 'Enter Your Email Address',
            signInWithoutPassword: 'Sign in email',
            successTitle: 'Success',
            resetPasswordEmailSent:
              'We have sent you a password reset link to your email address.',
            loading: 'Loading',
            Error: 'Error',
            MessageEmailPass: 'Invalid email',
            ErrorMessage: 'Failed to send sign-in email. Please try again.',
            EmailSent: 'Email Sent',
            EmailSentMessage: `A sign-in link has been sent to the user's email.`,
            SignInCancelled: 'Sign In Cancelled',
            SignInCancelledMessage: 'You have cancelled the sign-in process.',
            errorTitle: 'Error',
            errorMessage: 'Failed to send sign-in email. Please try again.',
            checkEmailTitle: 'Check your email',
            magicLinkSent:
              'A sign-in link has been sent to your email address.',
            tryDifferentEmail: 'Try a different email address',
            sendMagicLink: 'Send Sign In Link',
            checkEmail: 'Check your email',
            passwordLogin: 'Password Login',
            magicLink: 'Magic Link',
            forgot: 'Forgot Password',
            resetEmailSent: 'Reset email sent',
            checkEmailReset: 'Check your email for the reset link.',
            emailLabel: 'Email',
            passwordLabel: 'Password',
            sendResetLink: 'Send Reset Link',
            success: 'Success',
            welcomeBack: 'Welcome back',
            emailSent: 'Email sent',
            sending: 'Sending...',
            // OTP related translations
            otpCode: 'Verification Code',
            otpSentTo: 'Enter the 6-digit code sent to',
            otpLabel: 'OTP Code',
            otpRequired: 'Verification code is required',
            otpInvalid: 'Verification code must be 6 digits',
            continueWithOtp: 'Continue',
            sendingOtp: 'Sending...',
            verifying: 'Verifying...',
            verifyAndSignIn: 'Verify & Sign In',
            backToLogin: 'Back to Login',
            resendOtp: 'Resend Code',
            otpSent: 'Verification code sent',
            checkEmailOtp: 'Check your email for the verification code',
            otpResent: 'Verification code resent',
            InvalidOtp: 'Invalid verification code. Please try again.',
            emailRequired: 'Email is required',
            invalidEmail: 'Please enter a valid email address',
            pleaseWait: 'Please wait',
            seconds: 'seconds before sending another code',
            rateLimitError:
              'Too many requests. Please wait before trying again.',
            securityWait:
              'For security purposes, you can only request this after',
            secondsShort: 'seconds',
            securityMessage: 'For security purposes, please wait',
            secondsBeforeRetry: 'seconds before trying again',
            // Username/Password login
            signInWithPassword: 'Sign In with Password',
            password: 'Password',
            passwordRequired: 'Password is required',
            invalidCredentials: 'Invalid email or password',
            forgotPasswordLink: 'Forgot Password?',
            signInButton: 'Sign In',
            signingIn: 'Signing in...',
            switchToOtp: 'Continue with OTP instead',
            switchToPassword: 'Sign in with password',
          },
          ResetPassword: {
            title: 'Update Password',
            newPassword: 'New Password',
            confirmPassword: 'Confirm Password',
            updatePassword: 'Update Password',
            success: 'Success',
            passwordUpdated: 'Your password has been updated successfully',
            error: 'Error',
            invalidLink: 'Invalid Reset Link',
            pleaseRequestNew: 'Please request a new password reset link',
            passwordTooShort: 'Password must be at least 6 characters',
            passwordsDoNotMatch: 'Passwords do not match',
            passwordRequired: 'Password is required',
          },
          HeaderEmployee: {
            name: 'Name',
            company: 'Company',
            clearOnBehalf: 'Clear on-behalf session',
            current: 'current',
            selectDepartment: 'Select Department',
            department: 'Deparment',
            onBehalfSettings: 'On-behalf settings',
            settings: 'Settings',
            toggleDetails: 'Toggle Details',
            exit: 'Exit',
            onBehalfModeActive:
              'Acting on behalf of another user - All actions will be performed as this user',
            onBehalfOf: 'On behalf of user',
            loading: 'Loading ...',
            selectUserToImpersonate: 'Select Employee to Act on Behalf of',
            active: 'Active',
            noUsersAvailable: 'No users available',
            position: 'Position',
            failedToSwitchUser: 'Failed to switch user. Please try again.',
            errorSwitchingUser: 'An error occurred while switching users.',
            cannotSwitchUser: 'Cannot switch users. Feature not available.',
            failedToFetchUserData:
              'Failed to fetch user data. Please try again.',
            noPosition: 'No position',
          },
          today: 'Today',
          months: {
            January: 'January',
            February: 'February',
            March: 'March',
            April: 'April',
            May: 'May',
            June: 'June',
            July: 'July',
            August: 'August',
            September: 'September',
            October: 'October',
            November: 'November',
            December: 'December',
          },
          monthsShort: {
            Jan: 'Jan',
            Feb: 'Feb',
            Mar: 'Mar',
            Apr: 'Apr',
            May: 'May',
            Jun: 'Jun',
            Jul: 'Jul',
            Aug: 'Aug',
            Sep: 'Sep',
            Oct: 'Oct',
            Nov: 'Nov',
            Dec: 'Dec',
          },
          absenceTable: {
            summary: 'Summary',
            detailView: 'Detailed View',
            groupView: 'Grouped View',
            COLOR: 'COLOR',
            ABSENCETYPE: 'Absence Type',
            PERIOD: 'PERIOD',
            UNIT: 'UNIT',
            STATE: 'STATE',
            ACTION: 'ACTION',
            confirmation: 'Delete Confirmation',
            message: 'You are about to delete this data entry.',
            cancel: 'Cancel',
            confirm: 'Confirm',
            allData: 'All Data',
            currentMonth: 'Current Month',
            downloadDocument: 'Download Document',
            approved: 'Approved',
            pending: 'Preview',
            pendingApproval: 'Pending Approval',
            success: 'Success',
            absenceRecordRemoved: 'The absence record has been removed.',
            error: 'Error',
            errorMessage: 'Failed to delete the data:',
            Downloaded: 'Downloaded',
            document: 'document',
            s: 's',
            FailedToDownload: 'Failed to download the files. Please try again.',
            ValidationError: 'Validation Error',
            DataConsistencyError: 'Data Consistency Error',
            DataConsistancyErrorDesc:
              'The leave allowance data has been modified. Please refresh the page to get the latest data.',
          },
          Documents: {
            title: 'Sign Documents',
            titleNotice: 'Notice',
            titleMyDocs: 'My Documents',
            titleAttached: 'Attached Documents',
            department: 'Department',
            selectDepartment: 'Select a department',
            organization: 'Organization',
            requestedBy: 'Requested by',
            selectUser: 'Select user...',
            searchUser: 'Search user...',
            noUserFound: 'No user found.',
            request: 'Request',
            startDate: 'Start Date',
            endDate: 'End Date',
            leaveType: 'Leave type',
            total_days: 'Total days',
            used_days: 'Used Days',
            remaining_days: 'Remaining Days',
            selectLeaveType: 'Select leave type',
            documentStatus: 'Document Status',
            selectDocumentStatus: 'Select document status',
            all: 'All',
            toBeSigned: 'To Be Signed',
            signed: 'Signed',
            rejected: 'Rejected',
            notSigned: 'Not Signed',
            year: 'Year',
            selectedFilters: 'Selected filters',
            result: 'Result',
            downloadAll: 'Download All',
            employee: 'Employee',
            pNumber: 'P Number',
            type: 'Type',
            period: 'Period',
            duration: 'Duration',
            approval: 'Approval',
            status: 'Status',
            action: 'Action',
            pleaseSelectDepartment: 'Please select a department',
            noDataAvailable: 'No data available for this department',
            showing: 'showing',
            to: 'to',
            of: 'of',
            entries: 'entries',
            SignAllDocuments: 'Sign All Documents',
            Processing: 'Processing...',
            SignDocument: 'Sign Document',
            SelectCertificateBP: 'Select Certificate for Batch Processing',
            SelectCertificate: 'Select Certificate',
            documents: 'documents',
            download: 'Download',
            allDepartments: 'All Departments',
            search: 'Search',
            allLeaveTypes: 'All Leave Types',
            pleaseSelectOneDepartment: 'Please select one department',
            GoTo: 'Go To',
            downloadProgress: 'Download Progress',
            downloadProgressDetails:
              'Processing {{current}} of {{total}} files',
            abortDownload: 'Abort Download',
            documentName: 'Document Name',
            documentType: 'Document Type',
            description: 'Description',
            date: 'Date',
            actions: 'Actions',
            filterByDate: 'Filter by Date',
            downloading: 'Downloading...',
            generatePdf: 'Generate PDF',
            previous: 'Previous',
            next: 'Next',
            page: 'Page',
            orderFor: 'Order for',
            order: 'Order',
            periodFrom: 'Period from',
            resignationOrderFor: 'Resignation order for',
            annualLeaveNotice: 'Annual leave notice',
            notice: 'Notice',
            annualLeaveNoticeDescription: 'Annual leave notice description',
            auditTrail: 'Document Audit Trail',
            auditTrailDescription:
              'View document creation and processing history',
            documentDetails: 'Document Details',
            auditInformation: 'Audit Information',
            documentCreated: 'Document Created',
            documentSent: 'Document Sent',
            signedDate: 'Signed Date',
            resignedDate: 'Resigned Date',
            noAuditDataAvailable: 'No audit data available for this document',
            close: 'Close',
            selectDocumentType: 'Select document type', // Audit trail actions
            created: 'created',
            sendForApproval: 'send for approval',
            approved: 'approved',
            actionSigned: 'signed',
            availableToEmployee: 'available to employee',
            downloaded: 'downloaded',
            resigned: 'resigned',
            generated: 'generated',
            // Audit trail descriptions
            documentCreatedDesc: 'Document is created and signed by',
            documentSentForApprovalDesc:
              'Documentis sent for approval to approval manager',
            documentApprovedDesc:
              'Document is approved and sent to be signed company manager',
            documentSignedDesc: 'Document is signed by company manager',
            documentSignedOrderDesc: 'Document is signed by company manager',
            documentAvailableDesc: 'Document is available to download',
            documentAvailableOrderDesc: 'Document is available to download',
            documentDownloadedDesc: 'Download document',
            documentResignedDesc: 'Document is signed by company manager',
            documentGeneratedDesc: 'Document generated',
            failedToGenerateDownloadUrl: 'Failed to generate download URL',
            httpError: 'HTTP error! status:',
            loading: 'Loading user data...',
          },
          CalendarMain: {
            clear: 'Clear',
            select: 'Select',
            Mon: 'Mon',
            Tue: 'Tue',
            Wed: 'Wed',
            Thu: 'Thu',
            Fri: 'Fri',
            Sat: 'Sat',
            Sun: 'Sun',
          },
          SelectedDay: {
            daysLeft: 'days left',
            More: 'More',
            Select: 'Select',
            SelectedDays: 'Leave request',
            DetailedView: 'Detailed View',
            Date: 'Date',
            Period: 'Period',
            Type: 'Type',
            Day: 'Day',
            Details: 'Details',
            Time: 'Time',
            AllDay: 'All Day',
            HalfDay: 'Half Day',
            BeforeLunch: 'Before Lunch',
            AfterLunch: 'After Lunch',
            Other: 'Other',
            ChooseFiles: 'Choose Files',
            Attachments: 'Attachments',
            NoFileChosen: 'No File Chosen',
            file: 'file',
            single: '',
            multi: 's',
            selected: 'selected',
            SelectReplacement: 'Select Replacement',
            Replacement: 'Replacement',
            TotalDaysSelected: 'Total Days Selected',
            EnterDescription: 'EnterDescription',
            Description: 'Description',
            SelectType: 'Select Type',
            Confirm: 'Confirm',
            Cancel: 'Cancel',
            Save: 'Save',
            Back: 'Back',
            Error: 'Error',
            FailedToFetch: 'Failed to fetch department employees',
            AnUnexpectedError:
              'An unexpected error occurred while fetching employees',
            InvalidSelection: 'Invalid Selection',
            YourSelection:
              "You've selected a leave type with no remaining days.",
            CannotSelectThisLeaveType: 'Cannot select this leave type',
            NotEnoughRemainingDaysFor: 'Not enough remaining days for',
            FileTooLarge: 'File too large',
            FilesTooLarge: 'Files too large',
            TotalAttachmentsExceed: 'Total attachments exceed',
            MaxFileSize: 'Max file size',
            InvalidFileType: 'Invalid file type',
            HalfDayLocked: 'Half-day selection cannot be changed',
            AllowedTypes: 'Allowed types',
            YourSelectionOrNotEnough:
              'There are not enough days remaining for the selected leave type.',
            TooManyFiles: 'Too many files',
            MaximumFilesAllowed: 'Maximum files allowed',
            DuplicateFilesSkipped: 'Duplicate files skipped',
            SkippedFiles: 'Skipped files',
            FilesAdded: 'Files added successfully',
            added: 'added',
          },
          LeaveTracker: {
            NoAllowances: '',
            daysUsed: 'days used',
            daysRemaining: 'days remaining',
            TotalDays: 'Total Days',
            UsedDays: 'Used Days',
            RemainingDays: 'Remaining Days',
          },
          weekdays: {
            Mon: 'Mon',
            Tue: 'Tue',
            Wed: 'Wed',
            Thu: 'Thu',
            Fri: 'Fri',
            Sat: 'Sat',
            Sun: 'Sun',
            Monday: 'Monday',
            Tuesday: 'Tuesday',
            Wednesday: 'Wednesday',
            Thursday: 'Thursday',
            Friday: 'Friday',
            Saturday: 'Saturday',
            Sunday: 'Sunday',
          },
          MyDeparment: {
            Today: 'Today',
            Employee: 'Employee',
            Summary: 'Summary',
            NoDataAvailable: 'No Data Available',
            allData: 'All Data',
            workSchedule: 'Work Schedule',
            absence: 'Absence',
            Error: 'Error',
            FailedFetch: 'Failed to fetch department data',
            Confirm: 'Confirm',
            Cancel: 'Cancel',
            Clear: 'Clear',
            Delete: 'Delete',
            SaveAndSend: 'SaveAndSend',
            Success: 'Success',
            WorkSaved: 'Work schedule saved successfully',
            SaveCancelled: 'Save cancelled',
            SelectType: 'Select work type',
            Minimize: 'Minimize',
            Maximize: 'Maximize',
            Hours: 'hours',
          },
          CompanyManagement: {
            CompanyManagement: 'Company Management',
            AddEmployee: 'Add Employee',
            AddDepartment: 'Add Department',
            ManageEmployees: 'Manage Employees',
            ManageManagers: 'Manage Managers',
            ManageDepartments: 'Manage Departments',
            Allowances: 'Allowances',
            Position: 'Position',
            Payment: 'Work Time',
            LeaveTypes: 'Leave Types',
            Holidays: 'Holidays',
            DataImport: 'Data Import',
            Integrations: 'Integrations',
            Upgrade: 'Upgrade',
            Search: 'Search',
            Calendars: 'Calendars',
            Reports: 'Reports',
            Test: 'Test',
            Company: 'Company',
            Sign: 'Sign',
            StartMenu: 'Start Menu',
            CompanyName: 'Company',
            Files: 'Attached Files',
            Notice: 'Notice',
            WorkTypes: 'Work Schedule',
          },
          Approvals: {
            SearchEmployeeName: 'Search Employee Name...',
            pendingApproval: 'Pending Approval',
            Approved: 'Approved',
            Department: 'Department',
            EmployeeName: 'Name',
            LeaveDescription: 'Description',
            LeavePeriod: 'Period',
            Duration: 'Count',
            Status: 'Status',
            Details: 'Details',
            Actions: 'Actions',
            Approve: 'Approve',
            Reject: 'Reject',
            Date: 'Date',
            Type: 'Type',
            Description: 'Description',
            Attachments: 'Attachments',
            Time: 'Time',
            Hours: 'Hours',
            Close: 'Close',
            AddAllowance: 'Add Allowance',
            ConfirmAction: 'Confirm Action',
            ConfirmReject:
              'Are you sure you want to reject this leave request?',
            Cancel: 'Cancel',
            ConfirmRejectAction: 'Reject',
            ConfirmApproveAction: 'Approve',
            ConfirmApprove:
              'Are you sure you want to approve this leave request?',
            summary: 'Summary',
            details: 'Details',
            attachments: 'Attachments',
            leaveRequest: 'Leave Request',
            total: 'Total',
            days: 'days',
            day: 'day',
            аpprovedBy: 'Аpproved By',
            NoAttachments: 'No Attachments',
            Replacement: 'Replacement',
            Download: 'Download',
            NoPendingApprovals: 'No Pending Approvals',
            NoApprovedItems: 'No Approved Items',
            approved: 'approved',
            rejected: 'rejected',
            Page: 'Page',
            of: 'of',
            Showing: 'Showing',
            AllApproved: 'All Approved',
            AllDeleted: 'All Deleted',
            NoSearchResults: 'No search results found',
          },
          AbsenceType: {
            Confirmation: 'Confirmation',
            YouAreAboutToSend:
              'You are about to send data to your manager for approval',
            Confirm: 'Confirm',
            Cancel: 'Cancel',
            Sending: 'Sending...',
            Success: 'Success',
            DataSuccessfully: 'Data successfully sent to your manager',
            Error: 'Error',
            ErrorDesription: 'There was an error updating the document',
            FileUploadError: 'File upload error',
            FailedToUpload: 'Failed to upload file',
            PleaseTryAgain: 'Please try again',
            ValidationError: 'Validation Error',
            ErrorModifyData:
              'The leave allowance data has been modified. Please refresh the page to get the latest data.',
            ErrorDuplicate:
              'Duplicate leave requests detected. Please ensure each request has a unique identifier.',
            MismatchIn: 'Mismatch in',
            Found: 'Found',
            DaysInSelectionButAllowanceShows:
              'days in selection but allowance shows',
            UsedDays: 'used days',
            ErrorDescription: 'Error sending data. Please try again.',
          },
          Session: {
            SessionExpired: 'Session Expired',
            SessionExpiredDesc:
              'Your session has expired. Please log in again.',
            SessionExtended: 'Session Extended',
            SessionExtendedDesc:
              'Your session has been extended for another hour.',
            SessionExpiringSoon: 'Session Expiring Soon',
            YourSessionWillExpireIn: 'Your session will expire in',
            minutes: 'minutes',
            ExtendSession: 'Extend Session',
          },
          AddEmployee: {
            AddEmployee: 'Add Employee',
            MiddleName: 'Middle Name',
            FirstName: 'First Name',
            LastName: 'Last Name',
            EmploymentStart: 'Employment Start Date',
            EmploymentEnd: 'Employment End Date',
            PickADate: 'Pick a date',
            Email: 'Email',
            Roles: 'Roles',
            Department: 'Department',
            EmployeeCode: 'Employee Code',
            Position: 'Position',
            Payment: 'Work Time',
            Employee: 'Employee',
            Approver: 'Approver',
            Admin: 'Admin',
            Cancel: 'Cancel',
            General: 'General',
            Organization: 'Organization',
            Other: 'Other',
            WorkTime: 'Work Time',
            UnusedAllowanceDays: 'Unused Allowance Days',
            Role: 'Role',
            WorkHours: 'Work Hours',
            PleaseSelectCompany: 'Please select company',
            SelectRole: 'Select Role',
            SelectWorkTime: 'Select work time',
            Standard: 'Standard',
            StandardOver: 'Standard + overtime',
            ByHour: 'By hour',
            ListedAnnualLeaves: 'Listed Annual Leaves',
            TotalАmount: 'Total amount',
            Days: 'Days',
            Creating: 'Creating employee ...',
            UserCreatedSuccessfully: 'User created successfully',
            Error: 'Error',
            ErrorEmail: 'The email address is not valid.',
            ErrorOrganization: 'Selected organization not found',
            ErrorEmailAlreadyExists: 'The email address is already in use.',
            ErrorEmployeeCode: 'Employee code already exists',
            ErrorFailed: 'Failed to create user',
            ErrorCustomClaim: 'Failed to set custom claim',
            Success: 'Success',
            CurrentYear: 'Current Year',
            TotalDays: 'Total Days',
            UsedDays: 'Used Days',
            RemainingDays: 'Remaining Days',
            AddPreviousYear: 'Add Previous Year',
            RemoveYear: 'Remove Year',
            AddAndInvite: 'Add and Invite',
            UserCreatedAndInvited: 'User created and invited successfully',
            Processing: 'Processing ...',
          },
          AddDeparment: {
            CreateNewDepartment: 'Create New Department',
            DepartmentName: 'Department Name',
            DepartmentLocation: 'Department Location',
            message: 'Please enter both the department name and location.',
            Create: 'Create',
            DepartmentAlreadyExists: 'Department already exists',
            ADepartmentWithName: 'A department with name',
            Andlocation: 'and location',
            AlreadyExistsForThisCompany: 'already exists for this company',
            DepartmentCreated: 'Department created',
            Department: 'Department',
            CreatedSuccessfully: 'created successfully',
            Error: 'Error',
            ErrorMessage: 'An error occurred while processing your request',
          },
          CreationStepsWizard: {
            Based:
              'Based on the country of your company the following template is selected:',
            MessageDeparments:
              'Please enter your departments, or if you wish you can press the "Next" button and enter them later.',
            MessageEmployees:
              'Please enter your departments, or if you wish you can press the "Next" button and enter them later.',
          },
          ManageDepartments: {
            CreateNewDepartment: 'Create New Department',
            DepartmentName: 'Department Name',
            DepartmentLocation: 'Department Location',
            message: 'Please enter both the department name and location.',
            ManageDepartments: 'Manage Departments',
            SaveChanges: 'Save Changes',
            Name: 'Name',
            Approver: 'Approver',
            Location: 'Location',
            Actions: 'Actions',
            NoDataAvailable: 'No Data Available',
            AddDepartment: 'Add Department',
            Create: 'Create',
            Cancel: 'Cancel',
            Delete: 'Delete',
            Saving: 'Sending ...',
            ConfirmDeletion: 'Confirm Deletion',
            ConfirmDeletionMessage:
              'Are you sure you want to delete this department?',
            Error: 'Error',
            ErrorMessageOne: 'Error fetching data. Please try again later',
            ErrorMessageTwo:
              'Error adding new department. Please try again later.',
            ErrorMessageThree: 'Error saving changes.',
            MissingInformation: 'Missing Information',
            DepartmentAdded: 'Department Added',
            DepartmentAddedМessage: 'Department added successfully',
            DepartmentExists: 'Department Exists',
            DepartmentExistsMessage: 'Department already exists',
            ChangesSaved: 'Changes Saved',
            ChangesSavedMessage: 'All changes saved successfully',
            DepartmentDeleted: 'Department Deleted',
            DepartmentDeletedMessage: 'was deleted successfully.',
            DeletionFailed: 'Deletion Failed',
            DeletionFailedMessage:
              'Cannot delete this department as it has associated data. First delete the associated data.',
            ErrorFetch: 'Error fetching data. Please try again later.',
            DepartmentAddedMessage: 'Department added successfully',
            ApproversUpdated: 'Approvers Updated',
            ApproversUpdatedMessage:
              'Department approvers updated successfully',
            ErrorUpdatingApprovers:
              'Error updating approvers. Please try again later.',
            ErrorDeletingDepartment:
              'Error deleting department. Please try again later.',
          },
          ManageManagers: {
            ManageManagers: 'Manage Managers',
            ManagerName: 'Manager Name',
            ManagerDepartment: 'Departments',
            ApprovalManager: 'Approval Manager',
            SelectApprovers: 'Select Approvers',
            SaveChanges: 'Save Changes',
            Apply: 'Apply',
            SuccessTitle: 'Success',
            NoApproversFound: 'No Approvers Found',
            successTitle: 'Success',
            ChangesSaved: 'Changes Saved',
            ErrorTitle: 'Error',
            ErrorDescription: 'Error saving changes. Please try again later.',
            SelectManagers: 'Select Managers',
            EmployeesSelected: 'employees selected',
            ApplyChanges: 'Apply Changes',
            Cancel: 'Cancel',
            Company: 'Company',
          },
          Allowances: {
            Allowance: 'Allowance Policies',
            Description: 'Description',
            Policy: 'Policy',
            Actions: 'Actions',
            NoDataAvailable: 'No data available',
            AllowancePolicy: 'Allowance Policy',
            AllowanceName: 'Allowance Name',
            AllowanceDescription: 'Allowance Description',
            AnnualDays: 'Annual Days',
            DaysPerYear: 'Days per year',
            DaysForYear: 'Days for year',
            AllowanceForMonth: 'Allowance For Month',
            AddAllowance: 'Add Allowance',
            AddAllowancePolicy: 'Add Allowance Policy',
            EditAllowancePolicy: 'Edit Allowance Policy',
            CarryOver: 'Carry over',
            CarryOverNo: 'No carry over',
            MaximumCarryOver: 'Maximum carry over',
            Unused: 'Unused allowance carries forward to next year',
            Days: 'days',
            Months: 'months',
            NeverExpire: 'never expire',
            ExpiryUnit: 'Expiry unit',
            CarryOverExp: 'Carry over expires after',
            Cancel: 'Cancel',
            Save: 'Save',
            CarryOverUpTo: 'Carry over up to',
            ErrorOne: 'Allowance Name and Annual Days are required',
            ErrorTwo: 'Annual Days must be greater than 0',
            ConfirmDeleteMessage:
              'Are you sure you want to delete this allowance policy?',
            Delete: 'Delete',
            ConfirmDelete: 'Confirm Delete',
          },
          LeaveTypes: {
            Name: 'Name',
            Color: 'Color',
            Description: 'Description',
            Actions: 'Actions',
            LeaveTypes: 'Leave Types',
            DisplayColor: 'Display Color',
            NoDataAvailable: 'No data available',
            DeductFromAllowance: 'Deduct from allowance',
            SelectedAllowance: 'Selected Allowance',
            CodeInUse: 'Cannot delete this code',
            CodeInUseDescription:
              'This code is currently in use and cannot be deleted.',
            AddLeaveType: 'Add Leave Type',
            DoesNotDeduct: 'Does Not Deduct',
            Deduct: 'Deduct',
            WorkSchedule: 'Work Schedule',
            is_hidden: 'Hidden type',
            CodeAlreadyExists: 'Code already exists',
            Code: 'Code',
            Type: 'Type',
            Main: 'Main Screen',
            SelectACode: 'Select a code',
            EditCodes: 'Edit Codes',
            ExistingCodes: 'Existing Codes',
            AddCode: 'Add Code',
            Close: 'Close',
            Update: 'Update',
            AbsenceLeaves: 'Absence Leaves',
            SaveChanges: 'Save Changes',
            SaveCodes: 'Save',
            UpdateCode: 'Update',
            DeleteConfirmation: 'Delete Confirmation',
            DeleteConfirmationMessage:
              'Are you sure you want to delete this data?',
            Delete: 'Delete',
            Cancel: 'Cancel',
            EditLeaveType: 'Edit Leave Type',
            UpdatedSuccessfully: 'Updated Successfully',
            SelectTypes: 'SelectTypes',
            Paid: 'Paid',
            Unpaid: 'Unpaid',
            Sick: 'Sick',
            Work: 'Work',
            ErrorOne: 'Name and Color are required.',
            LeaveTypeUpdatedSuccessfully: 'Leave type updated successfully',
            LeaveTypeAddedSuccessfully: 'Leave type added successfully',
            LeaveTypeDeleteSuccessfully: 'Leave type deleted successfully',
            ErrorSaving: 'Error saving leave type',
            ErrorDeleting: 'Error deleting leave type',
            LeaveTypeMovedUpSuccessfully: 'Leave type moved up successfully',
            LeaveTypeMovedDownSuccessfully:
              'Leave type moved down successfully',
            ErrorMovingLeaveTypeUp: 'Error moving leave type up',
            ErrorMovingLeaveTypeDown: 'Error moving leave type down',
            DuplicateNameError: 'Leave type name already exists',
            LeaveTypeNameExists: 'Leave type name already exists',
            Save: 'Save',
            AutoApproval: 'Auto Approval',
            DocRequired: 'Document Required',
            WorkTypes: 'Work Schedule',
            AddWorkType: 'Add Work Type',
            WorkScheduleTypes: 'Work Schedule Types',
            EditWorkType: 'Edit Work Type',
            WorkTypeAddedSuccessfully: 'Work type added successfully',
            WorkTypeUpdatedSuccessfully: 'Work type updated successfully',
          },
          Reports: {
            Reports: 'Reports',
            Form76: 'Form 76',
            SelectDepartment: 'Select Department',
            AllDepartments: 'All Departments',
            Download: 'Download Data',
            Error: 'Error',
            ErrorMessage:
              'Please select both a month and a department before downloading',
            ErrorReport: 'An error occurred while generating the report',
            FailedToLoadCode: 'Failed to load code options',
            NotReady: 'Not Ready',
            CodeLoading: 'Code options are still loading. Please wait.',
            SelectDate: 'Select Date',
            SelectDateMessage: 'Please select a date to view the report.',
          },
          employeeBulkUpload: {
            title: 'Bulk Employee Upload',
            description:
              'To import employees in bulk, please download the Excel template, fill in the details of your employees, and then upload the completed file.',
            uploadButton: 'Upload using Template',
            uploading: 'Uploading...',
            downloadTemplate: 'Download Template',
            firstName: 'First Name',
            middleName: 'Middle Name',
            lastName: 'Last Name',
            email: 'email',
            department: 'Department',
            employeeCode: 'Employee Code',
            position: 'Position',
            workhour: 'Work Hour',
            workHours: 'Work Hour',
            startDate: 'Start Date',
            endDate: 'End Date',
            role: 'Role',
            hasCustomAllowances: 'Has Custom Allowances',
            SelectFromList: 'Select from List',
            selectRole: 'Select Role',
            yes: 'YES',
            no: 'NO',
            employee: 'Employee',
            approver: 'Approver',
            admin: 'Admin',
            year: 'Year',
            type: 'Type',
            total_days: 'Total Days',
            remaining_days: 'Remaining Days',
            used_days: 'Used Days',
            id: 'ID',
            deploc: 'Department Location',
            exampleFirstName: 'John',
            exampleMiddleName: 'Doe',
            exampleLastName: 'Smith',
            exampleDepartment: 'HR',
            exampleEmployeeCode: 'EMP001',
            examplePosition: 'Manager',
            exampleWorkHour: '8',
            exampleStartDate: '2023-01-01',
            exampleEndDate: '',
            exampleRole: 'Chose role',
            departmentId: 'ID',
            departmentLocation: 'Department Location',
            invalidRole: 'Invalid role',
            invalidRoleMessage: 'Please select a valid role.',
            invalidDepartment: 'Invalid department',
            invalidDepartmentMessage: 'Please select a valid department.',
            invalidSelection: 'Invalid selection',
            invalidSelectionMessage: 'Please select a valid option.',
            worksheetEmployees: 'Employees',
            worksheetAllowances: 'Allowances',
            worksheetDepartments: 'Departments',
            sendEmailInvites: 'Send email invitations to new employees',
          },
          allowancesCard: {
            title: 'Allowances',
            description:
              'To import allowances please download this Excel (.xlsx) template, fill in the details of the allowances to import and then upload.',
            uploadButton: 'Upload using Template',
            downloadButton: 'Download Template',
            email: 'Email',
            leaveType: 'Leave Type',
            leaveTypeDescription: 'Leave Type Description',
            startDate: 'Start Date',
            endDate: 'End Date',
            hours: 'Hours',
            exampleEmail: 'example@company.com',
            exampleLeaveType: 'Annual Leave',
            exampleDescription: 'Regular annual leave',
            exampleStartDate: 'YYYY-MM-DD',
            exampleEndDate: 'YYYY-MM-DD',
            exampleHours: '8',
            emptyRow: 'All fields are empty',
            invalidEmail: 'Email is missing or invalid',
            missingLeaveType: 'Leave Type is missing',
            missingStartDate: 'Start Date is missing',
            missingEndDate: 'End Date is missing',
            missingHours: 'Hours is missing',
            invalidDateRange: 'End Date cannot be before Start Date',
            invalidLeaveType:
              '{{type}} does not match any in the Leave Types Data',
            emailNotFound: 'Email not found in the system',
            dateOverlap: 'Date overlap found with existing leave(s): {{dates}}',
            uploading: 'Uploading...',
          },
          DataImport: {
            NoData: 'Number',
            NonData: 'No Data',
            Status: 'Status',
            Reason: 'Reason',
            ImportStatus: 'Import Status',
            DataImport: 'Data Import',
          },
          Company: {
            Company: 'Company',
            Name: 'NAME',
            FirstDayOfWeek: 'First Day Of Week',
            AddCompany: 'Add Company',
            Actions: 'ACTIONS',
            CompanyName: 'Company Name',
            address: 'Address',
            Town: 'Town',
            Cancel: 'Cancel',
            Save: 'Save',
            Saving: 'Saving...',
            EditCompany: 'Edit Company',
            NoDataAvailable: 'No data available',
            ContactPerson: 'Contact Person',
            ContactEmail: 'Contact Email',
            ContactNumber: 'Contact Number',
            Country: 'Country',
            SelectCountry: 'Select country',
            Bulgaria: 'Bulgaria',
            UK: 'UK',
            USA: 'USA',
            VatNumber: 'VAT Number',
            AllowanceCalendarStart: 'Allowance Calendar Start',
            Monday: 'Monday',
            Sunday: 'Sunday',
            SelectFirstDayOfWeek: 'Select first day of week',
            Status: 'STATUS',
            Active: 'Active',
            Inactive: 'Inactive',
            Original: 'Original',
            MakeActive: 'Make Active',
            ActiveCompany: 'Active Company',
            OriginalCompany: 'Original Company',
            RevertToOriginal: 'Revert',
          },
          Holidays: {
            Holidays: 'Holidays',
            AddHoliday: 'Add Holiday',
            Year: 'Year',
            Country: 'Country',
            Language: 'Language',
            message: 'Please select year, country and language for holidays.',
            SelectYear: 'Select year',
            SelectACountry: 'Select country',
            SelectAlanguage: 'Select language',
            Date: 'Date',
            Name: 'Name',
            NoDataAvailable: 'No data available',
            AddToList: 'Add to list',
            NewHoliday: 'New Holiday',
            HolidaysFor: 'Holidays for',
            Location: 'Location',
            AssignedEmployees: 'Assigned Employees',
            NumberOfHolidays: 'Number Of Holidays',
            Actions: 'Actions',
            Summary: 'Summary',
            Cancel: 'Cancel',
            Save: 'Save',
            Close: 'Close',
          },
          EmployeesCard: {
            Employees: 'Employees',
            DownloadEmployeesData: 'Download Employees XLSX data',
            DownloadData: 'Download Data',
            ReportDate: 'Report Date',
            DepartmentID: 'Department',
            ID: 'ID',
            Name: 'Name',
            Email: 'Email',
            PersonnelNumber: 'Personnel Number',
            Role: 'Role',
            StartDate: 'Start Date',
            YearsOfService: 'Years of Service',
            ApproverID: 'Approver ID',
            ApproverName: 'Approver Name',
            Downloading: ' Downloading...',
          },
          LeaveCard: {
            Leave: 'Leave',
            DownloadLeaveData: 'Download leave data',
            DownloadData: 'Download Data',
            Downloading: 'Downloading...',
            ReportDate: 'Report Date',
            DepartmentID: 'Department',
            Name: 'Name',
            Email: 'Email',
            PersonnelNumber: 'Personnel Number',
            Role: 'Role',
            StartDate: 'Start Date',
            YearsOfService: 'Years of Service',
            Type: 'Type',
            Status: 'Status',
            EndDate: 'End Date',
            Description: 'Description',
            Hours: 'Hours',
            ApprovedBy: 'Approved By',
            Attachments: 'Attachments',
            status: {
              Approved: 'Approved',
              PendingApproval: 'Pending Approval',
              Deleted: 'Deleted',
            },
          },
          AllowanceCard: {
            Allowances: 'Allowances',
            DownloadAllowanceData: 'Download Employees XLSX data',
            DownloadData: 'Download Data',
            Downloading: 'Downloading...', // Added missing key
            SelectDate: 'Select Date',
            SelectYear: 'Select Year',
            ReportDate: 'Report Date',
            AllowanceName: 'Allowance Name',
            AllowanceDescription: 'Allowance Description',
            CalendarStart: 'Calendar Start',
            CalendarEnd: 'Calendar End',
            AnnualLeave: 'Annual Leave',
            CarryOver: 'Carry Over',
            MaxCarryOver: 'Max Carry Over',
            CarryOverExpires: 'Carry Over Expires',
            ExpiryUnit: 'Expiry Unit',
            DepartmentID: 'DepartmentID',
            ID: 'ID',
            Name: 'Name',
            Email: 'Email',
            PhoneNumber: 'Phone Number',
            Role: 'Role',
            StartDate: 'Start Date',
            YearsofService: 'Years of Service',
            AccruedAllowance: 'Accrued Allowance',
            TotalAllowance: 'Total Allowance',
            Used: 'Used',
            RemainingtoTake: 'Remaining to Take',
            CarriedfromLastYear: 'Carried from Last Year',
            Error: 'Error',
            FailedFetch: 'Failed to fetch department data',
            PleaseSelect: 'Please select a report date.',
          },
          ManageEmployees: {
            ManageEmployees: 'Manage Employees',
            Name: 'Name',
            FullName: 'Full Name',
            Edit: 'Edit',
            Email: 'Email',
            Role: 'Role',
            Actions: 'Actions',
            EditUser: 'Edit User',
            FirstName: 'First Name',
            LastName: 'Last Name',
            MiddleName: 'Middle Name',
            EmploymentStartDate: 'Employment Start Date',
            EmploymentStartEnd: 'Employment End Date',
            Employee: 'Employee',
            Approver: 'Approver',
            Admin: 'Admin',
            EmployeeCode: 'EmployeeCode',
            ImportedUnusedAllowanceDaysfromPreviousYears:
              'Imported Unused Allowance Days from Previous Years',
            DepartmentLocation: 'Department Location',
            Cancel: 'Cancel',
            NoDataAvailable: 'No data available',
            Delete: 'Delete',
            ConfirmDeleteMessage:
              'Are you sure you want to delete this employee?',
            ConfirmDelete: 'Confirm Delete',
            TypeDeleteToConfirm: 'Type "DELETE" to confirm',
            General: 'General',
            Organization: 'Organization',
            Other: 'Other',
            Department: 'Department',
            EmploymentStart: 'Employment Start',
            Roles: 'Roles',
            Position: 'Position',
            EmploymentEnd: 'Employment End',
            UpdateEmployee: 'Update Employee',
            Updating: 'Updating...',
            UpdateUser: 'Update User',
            WorkTime: 'Work Time',
            WorkHours: 'Work Hours',
            successTitle: 'Success',
            resetPasswordEmailSent: 'Reset password email sent',
            errorTitle: 'Something went wrong',
            ListedAnnual: 'Listed Annual Leaves for year',
            TotalDays: 'Total Days',
            UsedDays: 'Used Days',
            RemainingDays: 'Remaining Days',
            InviteEmployee: 'InviteEmployee',
            EditEmployee: 'Edit Employee',
            EnableEmployee: 'Enable Employee',
            DisableEmployee: 'Disable Employee',
            DeleteUser: 'Delete User',
            AddEmployee: 'Add Employee',
            magicLinkSent: 'Magic link sent',
            Error: 'Error',
            FailedFetch: 'Failed to fetch users',
            FailedUpdate: 'Failed to update user',
            FailedDelete: 'Failed to delete user',
            Success: 'Success',
            UserUpdated: 'User updated successfully',
            UserDeleted: 'User deleted successfully',
            UserLocked: 'User locked successfully',
            UserUnlocked: 'User unlocked successfully',
            FailedToLock: 'Failed to lock user',
            FailedToUnlock: 'Failed to unlock user',
            UnlockUser: 'Activate employee',
            LockUser: 'Disable employee',
            ConfirmLock: 'Confirm Lock',
            ConfirmLockMessage: 'Are you sure you want to lock this user?',
            LockUntilDate: 'Lock from date',
            ConfirmUnlock: 'Confirm activation',
            ConfirmUnlockMessage:
              'Are you sure you want to activate this user?',
            GoTo: 'Go to',
            Warning: 'Warning',
            PermanentDeleteWarning:
              'This operation is irreversible. All data associated with this employee will be deleted.',
            DeleteConfirmMessage:
              'Are you sure you want to delete this employee?',
            TypeEmailToConfirm: `Enter the employee's email to confirm.`,
            Type: 'Type',
            ToConfirm: 'to confirm',
            LoadingAllowances: 'Loading allowances...',
            NoAllowancesFound: 'No allowances found',
            AdvancedFiltering: 'Advanced Filtering',
            SearchByName: 'Search by name',
            SearchByCode: 'Search by code',
            SearchByDepartment: 'Search by department',
            SearchByRole: 'Search by role',
            ApplyFilters: 'Apply Filters',
            ClearFilters: 'Clear Filters',
            All: 'All',
          },
          Legend: {
            CodeLegend: 'Code Legend',
          },
          SetupData: {
            title: 'Set your new password',
            placeholder: 'Enter your new password',
            confirmPlaceholder: 'Confirm your new password',
            passwordTooShort: 'Password must be at least 6 characters',
            passwordsDontMatch: 'Passwords do not match',
            resetPasswordButton: 'Confirm',
            errorTitle: 'Error',
            invalidLinkDescription: 'Invalid link.',
            emailVerificationTitle: 'Email Verification',
            emailVerificationDescription:
              'Successfully verified your email address. You can now login.',
            newPasswordLabel: 'Password',
            confirmPasswordLabel: 'Confirm Password',
            passwordResetTitle: 'New Password',
          },
          AppUpdateNotification: {
            title: 'App Update Available',
            description:
              'A new version of the app is available. Please refresh to get the latest features and fixes.',
            refresh: 'Refresh Now',
            refreshing: 'Refreshing...',
            later: 'Later',
          },
          SignUp: {
            Hello: 'Hello',
            NewPassword: 'New Password',
            ConfirmNewPassword: 'Confirm New Password',
            CurrentPassword: 'Current Password',
            SuccessMessage: 'Password updated successfully',
            MessageOne: 'Please update your password.',
            MessageTwo:
              'The new password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.',
            ErrorOneA: 'Password must be at least',
            ErrorOneB: 'characters long.',
            ErrorTwo: 'Password must contain at least one uppercase letter.',
            ErrorThree: 'Password must contain at least one lowercase letter.',
            ErrorFour: 'Password must contain at least one number.',
            ErrorFive: 'Password must contain at least one special character.',
            ErrorSix: 'Passwords do not match.',
            ErrorSeven: 'No user is currently signed in',
            VerifyEmail: 'Verification email sent.',
            VerifyError: 'Error sending verification email:',
          },
          SetupCalendar: {
            LeaveYearCalendar: 'Leave Year Calendar',
            OptionOne: 'January 1st to December 31st',
            OptionTwo: 'April 1st to March 31st',
            OptionThree: 'Custom',
            Choose: 'Choose start date:',
            Message:
              "The leave year calendar sets the timeframe for when the calendar begins and end. During this period, leave allowances are refreshed, and if needed, any unused leave can be carried over. Typically, this aligns with the company's fiscal year.",
          },
          roles: {
            Admin: 'Admin',
            Approver: 'Approver',
            Employee: 'Employee',
          },
          ErrorBoundry: {
            Message: 'Something went wrong. Please refresh...',
            Updating: 'App is updating...',
            UpdateMessage:
              'We are refreshing the app to load the latest version. This will only take a moment.',
            RetryNow: 'Retry Now',
          },
          HomeDashboard: {
            Next: 'The Next 7 Days',
            NextSchedule: 'My Schedule for the next 7 days',
            Date: 'Date',
            Type: 'Type',
            Period: 'Period',
            Amount: 'Days',
            Status: 'Status',
            day: 'day',
            days: 'days',
            NoEvent: 'No events',
            Approved: 'Approved',
            PendingApproval: 'Pending Approval',
            Work: 'Work day',
            Notice: 'Notice',
            NoticeMessage: 'annual leave for',
            DownloadError: 'Download error',
          },
          Footer: {
            PrivacyPolicy: 'Privacy Policy',
            TermsOfService: 'Terms of Service',
            Copyright: 'All rights reserved.',
          },
        },
      },
      bg: {
        translation: {
          Yes: 'Да',
          No: 'Не',
          App: {
            loading: 'Зареждане',
          },
          NavBar: {
            VionHR: 'VionHR',
            home: 'Начало',
            login: 'Вход',
            logout: 'Излез',
            mydays: 'Моите дни',
            mydeparmant: 'Моят отдел ',
            approvals: 'Одобрения',
            companymanagement: 'Управление на компанията',
            companyregistration: 'Регистрация на компания',
            message: 'Имейлът на вашия имейл акаунт не е потвърден.',
            resendLink:
              'Натиснете тук, за да изпратите имейла за потвърждение.',
            myDocs: 'Моите документи',
          },
          Home: {
            welcomeBack: 'Здравей!',
            pleaseLogIn: 'Моля, влезте, за да видите вашия профил.',
            loading: 'Зареждане на данните ...',
          },
          Login: {
            signIn: 'Вход',
            signInWithEmail: 'Вход чрез емайл',
            forgotPassword: 'Забравена парола',
            resetPassword: 'Изпрати емайл с новара парола',
            passwordlessSignIn: 'Вход чрез емаил',
            sendSignInLink: 'Изпрати линк за вход',
            backToSignIn: 'Назад към вход',
            Confirm: 'Потвърди',
            ConfirmYourEmail: 'Потвърдете вашият имейл адрес',
            Email: 'Имейл адрес',
            EnterYourEmailAddress: 'Въведете вашият имейл адрес',
            signInWithoutPassword: 'Вход чрез емаил',
            successTitle: 'Успешно',
            resetPasswordEmailSent: 'Изпратихме ви линк вашия имейл адрес.',
            loading: 'Зареждане',
            Error: 'Грешка',
            MessageEmailPass: 'Невалиден имейл',
            ErrorMessage:
              'Неуспешно изпращане на имейл за вход. Моля, опитайте отново.',
            EmailSent: 'Имейлът е изпратен',
            EmailSentMessage: `На имейла на потребителя е изпратена връзка за вход.`,
            SignInCancelled: 'Входът е отменен',
            SignInCancelledMessage: 'Вие отменихте процеса на влизане.',
            errorTitle: 'Грешка',
            errorMessage: 'Грешка при вход. Моля, опитайте отново.',
            checkEmailTitle: 'Проверете вашият имейл',
            magicLinkSent: 'Изпратихме ви линк за вход на вашия имейл адрес.',
            tryDifferentEmail: 'Опитайте с друг имейл',
            sendMagicLink: 'Изпрати линк за вход',
            checkEmail:
              'Изпратихме ви линк за вход на вашия имейл адрес. Проветете в спам папката също.',
            passwordLogin: 'Вход с парола',
            magicLink: 'Линк за вход',
            forgot: 'Забравена парола',
            resetEmailSent: 'Проверете вашият имейл',
            checkEmailReset: 'Изпратихме ви линк за промяна на паролата',
            emailLabel: 'Имейл',
            passwordLabel: 'Парола',
            sendResetLink: 'Изпрати',
            success: 'Успешно',
            welcomeBack: 'Здравей отново!',
            emailSent: 'Изпратихме ви емайл',
            sending: 'Изпращане...',
            // OTP related translations
            otpCode: 'Код за потвърждение',
            otpSentTo: 'Въведете 6-цифрения код, изпратен на',
            otpLabel: 'OTP код',
            otpRequired: 'Кодът за потвърждение е задължителен',
            otpInvalid: 'Кодът за потвърждение трябва да бъде 6 цифри',
            continueWithOtp: 'Продължи',
            sendingOtp: 'Изпращане на ...',
            verifying: 'Проверяване...',
            verifyAndSignIn: 'Потвърди и влез',
            backToLogin: 'Назад към вход',
            resendOtp: 'Изпрати отново кода',
            otpSent: 'Кодът за потвърждение е изпратен',
            checkEmailOtp: 'Проверете емайла си за кода за потвърждение',
            otpResent: 'Кодът за потвърждение е изпратен отново',
            InvalidOtp: 'Невалиден код за потвърждение. Моля, опитайте отново.',
            emailRequired: 'Емайлът е задължителен',
            invalidEmail: 'Моля, въведете валиден емайл адрес',
            pleaseWait: 'Моля, изчакайте',
            seconds: 'секунди преди да изпратите нов код',
            rateLimitError:
              'Твърде много заявки. Моля, изчакайте преди да опитате отново.',
            securityWait:
              'От съображения за сигурност, можете да заявите това след',
            secondsShort: 'секунди',
            securityMessage: 'От съображения за сигурност, моля изчакайте',
            secondsBeforeRetry: 'секунди преди да опитате отново',
            // Username/Password login
            signInWithPassword: 'Вход с парола',
            password: 'Парола',
            passwordRequired: 'Паролата е задължителна',
            invalidCredentials: 'Невалиден имейл или парола',
            forgotPasswordLink: 'Забравена парола?',
            signInButton: 'Влез',
            signingIn: 'Влизане...',
            switchToOtp: 'Продължи с OTP вместо това',
            switchToPassword: 'Влез с парола',
          },
          HeaderEmployee: {
            name: 'Име',
            company: 'Фирма',
            clearOnBehalf: 'Изчистване на сесия от името',
            current: 'Текущ',
            selectDepartment: 'Изберете отдел',
            department: 'Отдел',
            onBehalfSettings: 'Настройки за действие от името на',
            settings: 'Настройки',
            toggleDetails: 'Детайли',
            exit: 'Изход',
            onBehalfModeActive:
              'Действие от името на друг потребител - Всички действия ще бъдат извършвани от името на този потребител',
            onBehalfOf: 'Действие от името на',
            loading: 'Зареждане ...',
            selectUserToImpersonate:
              'Изберете служител от име на когото искате да действате',
            active: 'Активен',
            noUsersAvailable: 'Няма налични потребители',
            position: 'Позиция',
            failedToSwitchUser:
              'Неуспешна смяна на потребител. Моля, опитайте отново.',
            errorSwitchingUser: 'Възникна грешка при смяна на потребител.',
            cannotSwitchUser:
              'Не може да се смени потребител. Функцията не е налична.',
            failedToFetchUserData:
              'Неуспешно зареждане на данни за потребителя. Моля, опитайте отново.',
            noPosition: 'Няма позиция',
          },
          today: 'Днес',
          months: {
            January: 'Януари',
            February: 'Февруари',
            March: 'Март',
            April: 'Април',
            May: 'Май',
            June: 'Юни',
            July: 'Юли',
            August: 'Август',
            September: 'Септември',
            October: 'Октомври',
            November: 'Ноември',
            December: 'Декември',
          },
          monthsShort: {
            Jan: 'Яну',
            Feb: 'Фев',
            Mar: 'Мар',
            Apr: 'Апр',
            May: 'Май',
            Jun: 'Юни',
            Jul: 'Юли',
            Aug: 'Авг',
            Sep: 'Сеп',
            Oct: 'Окт',
            Nov: 'Ное',
            Dec: 'Дек',
          },
          absenceTable: {
            summary: 'Обобщение',
            detailView: 'Детайлен изглед',
            groupView: 'Групов изглед',
            COLOR: 'Цвят',
            ABSENCETYPE: 'Тип',
            PERIOD: 'Период',
            UNIT: 'Брой',
            STATE: 'Статус',
            ACTION: 'Действие',
            confirmation: 'Потвърждение за изтриване',
            message: 'Вие ще изтриете данните за отсъствията',
            cancel: 'Отказ',
            confirm: 'Потвърждавам',
            allData: 'Всички',
            currentMonth: 'Текущ месец',
            downloadDocument: 'Изтегляне на документи',
            approved: 'Одобрено',
            pending: 'Преглед, не изпратено',
            pendingApproval: 'Изпратено, в процес на одобрение',
            success: 'Успешно',
            absenceRecordRemoved: 'Отсъствията са изтрити успешно',
            error: 'Грешка',
            errorMessage: 'Неуспешно изтриване на данните:',
            Downloaded: 'Изтелгени',
            document: 'документ',
            s: 'и',
            FailedToDownload:
              'Неуспешно изтегляне на файловете. Моля, опитайте отново.',
            ValidationError: 'Грешка при валидиране',
            DataConsistencyError: 'Грешка в последователността на данните',
            DataConsistancyErrorDesc:
              'Данните за отсъствие са променени. Моля, презаредете страницата, за да получите най-новите данни.',
          },
          Documents: {
            title: 'Подписване на документи',
            titleNotice: 'Подписаване на уведомления',
            titleMyDocs: 'Моите документи',
            titleAttached: 'Прикачени документи',
            department: 'Отдел',
            selectDepartment: 'Избери отдела',
            organization: 'Организация',
            requestedBy: 'Заявена от',
            selectUser: 'Избери служител...',
            searchUser: 'Търси служител...',
            noUserFound: 'Няма намерени служители',
            request: 'Заявка',
            startDate: 'Начална дата',
            endDate: 'Крайна дата',
            total_days: 'Общ дни',
            used_days: 'Използвани дни',
            remaining_days: 'Останали дни',
            leaveType: 'Тип',
            selectLeaveType: 'Избери тип отсъствие',
            documentStatus: 'Статус на документа',
            selectDocumentStatus: 'Избери статус на документа',
            all: 'Всички',
            toBeSigned: 'За подпис',
            signed: 'Подписани',
            year: 'Година',
            no_allowance: 'No allowances found',
            rejected: 'Отхвърлени',
            notSigned: 'Неподписани',
            selectedFilters: 'Избрани филтри',
            result: 'Резултати',
            downloadAll: 'Изтегляне на всички',
            employee: 'Служител',
            pNumber: 'Номер',
            type: 'Тип',
            period: 'Период',
            duration: 'Дни',
            approval: 'Одобрение',
            status: 'Статус',
            action: 'Действие',
            pleaseSelectDepartment: 'Моля изберете отдела',
            noDataAvailable: 'Няма налични данни',
            showing: 'Показване',
            to: 'от',
            of: 'до',
            entries: 'записи',
            SignAllDocuments: 'Подпис на всичко',
            Processing: 'Обработка...',
            SignDocument: 'Подпис на документ',
            SelectCertificateBP: 'Избери сертификат',
            SelectCertificate: 'Избери сертификат',
            documents: 'документи',
            download: 'Изтегли',
            allDepartments: 'Всички отдели',
            search: 'Търси',
            allLeaveTypes: 'Всички типове отсъствия',
            pleaseSelectOneDepartment: 'Моля изберете един отдел',
            GoTo: 'Отиди на',
            downloadProgress: 'Процес на изтегляне',
            downloadProgressDetails:
              'Обработка {{current}} от {{total}} файлове',
            abortDownload: 'Прекрати изтеглянето',
            documentName: 'Име на документа',
            documentType: 'Тип',
            description: 'Описание',
            date: 'Дата',
            actions: 'Действия',
            filterByDate: 'Филтриране по дата',
            downloading: 'Изтегляне...',
            generatePdf: 'Генериране на PDF',
            previous: 'Предишна',
            next: 'Следваща',
            page: 'Страница',
            orderFor: 'Заповед за',
            order: 'Заповед',
            periodFrom: 'Период от',
            resignationOrderFor: 'Заповед за отказ от',
            annualLeaveNotice: 'Уведомление за право на платен годишен отпуск',
            notice: 'Уведомление',
            annualLeaveNoticeDescription:
              'Описание на уведомлението за годишен отпуск',
            auditTrail: 'Одитна следа на документа',
            auditTrailDescription:
              'Преглед на историята на създаване и обработка на документа',
            documentDetails: 'Детайли за документа',
            auditInformation: 'Одитна информация',
            documentCreated: 'Документът е създаден',
            documentSent: 'Документът е изпратен',
            signedDate: 'Дата на подписване',
            resignedDate: 'Дата на отказ',
            noAuditDataAvailable:
              'Няма налична одитна информация за този документ',
            close: 'Затвори',
            selectDocumentType: 'Избери тип документ', // Audit trail actions
            created: 'създаден',
            sendForApproval: 'изпратен за одобрение',
            approved: 'одобрен',
            actionSigned: 'подписан',
            availableToEmployee: 'достъпен за служителя',
            downloaded: 'изтеглен',
            resigned: 'отхвърлен',
            generated: 'генериран',
            // Audit trail descriptions
            documentCreatedDesc: 'Документа е създаден и подписан от',
            documentSentForApprovalDesc:
              'Документа е изпратен за одобрение до одобряващия мениджър',
            documentApprovedDesc:
              'Документа е одобрен и изпратен за подписване от управителя',
            documentSignedDesc: 'Документа е подписан от управителя',
            documentSignedOrderDesc: 'Документа е подписан от управител',
            documentAvailableDesc: 'Документа е налични за изтегляне',
            documentAvailableOrderDesc: 'Документа е налични за изтегляне',
            documentDownloadedDesc: 'Изтегляне на документ',
            documentResignedDesc: 'Документа е подписан от управителя',
            documentGeneratedDesc: 'Документът е генериран',
            failedToGenerateDownloadUrl:
              'Неуспешно генериране на URL за изтегляне',
            httpError: 'HTTP грешка! статус:',
            loading: 'Зареждане на данните ...',
          },
          AbsenceType: {
            Confirmation: 'Потвърждение за изпращане',
            YouAreAboutToSend: 'Данните ще бъдат изпратени за одобрение.',
            Confirm: 'Изпрати',
            Cancel: 'Откажи',
            Sending: 'Изпращане...',
            Success: 'Успешно изпратено',
            DataSuccessfully: 'Данните са изпратени успешно до вашия мениджър.',
            STATE: 'Статус',
            ACTION: 'Действие',
            Error: 'Грешка',
            ErrorDesription: 'Грешка при изпращане на данни.',
            FileUploadError: 'Грешка при качване на файл',
            FailedToUpload: 'Неуспешно качване на файл',
            PleaseTryAgain: 'Моля, опитайте отново',
            ValidationError: 'Грешка при валидация',
            DataConsistencyError: 'Грешка при проверка на данните',
            ErrorModifyData:
              'Данните за отсъствия са променени. Моля, презаредете страницата, за да получите най-новите данни.',
            ErrorDuplicate:
              'Открити са дублирани заявки за отпуск. Моля, уверете се, че всяка заявка има уникален идентификатор.',
            MismatchIn: 'Разминаване, моля презаредете !',
            Found: 'Избрани',
            DaysInSelectionButAllowanceShows: 'дните, но',
            UsedDays: 'използвани дни',
            ErrorDescription:
              'Грешка при изпращане на данни. Моля, опитайте отново.',
          },
          CalendarMain: {
            clear: 'Изчисти',
            select: 'Избери',
          },
          SelectedDay: {
            daysLeft: 'оставащи дни',
            More: 'Още',
            Select: 'Избери',
            SelectedDays: 'Заявка за отсъствия',
            DetailedView: 'Детайлен изглед',
            Date: 'Дата',
            Period: 'Период',
            Type: 'Тип',
            Day: 'Ден',
            Details: 'Детайли',
            Time: 'Времетраене',
            AllDay: 'Цял ден',
            HalfDay: 'Половин ден',
            BeforeLunch: 'Преди обяд',
            AfterLunch: 'След обяд',
            Other: 'Друго',
            ChooseFiles: 'Избери файл',
            Attachments: 'Прикачи',
            NoFileChosen: 'Няма избран файл',
            file: 'файл',
            single: '',
            multi: 'а',
            selected: '',
            SelectReplacement: 'Избери заместник',
            Replacement: 'Заместник',
            TotalDaysSelected: 'Общо избрани дни',
            EnterDescription: 'Въведете описание',
            Description: 'Описание',
            SelectType: 'Избери тип',
            Confirm: 'Потвърди',
            Cancel: 'Отказ',
            Save: 'Запази',
            Back: 'Назад',
            Error: 'Error',
            FailedToFetch: 'Неуспешно изтегляне на данните за отдела',
            AnUnexpectedError:
              'Възникна неочаквана грешка при изтегляне на данните за служителя',
            InvalidSelection: 'Невалиден избор',
            YourSelection: 'Избрали сте тип отсъствие без оставащи дни.',
            CannotSelectThisLeaveType: 'Не може да се избере този тип отпуск',
            NotEnoughRemainingDaysFor: 'Няма достатъчно оставащи дни за',
            FileTooLarge: 'Файлът е твърде голям',
            FilesTooLarge: 'Файловете са твърде големи',
            TotalAttachmentsExceed:
              'Общият размер на прикачените файлове надвишава',
            MaxFileSize: 'Максимален размер на файла',
            InvalidFileType: 'Невалиден тип файл',
            HalfDayLocked: 'Избраното половин ден не може да бъде променено',
            AllowedTypes: 'Разрешени типове файлове',
            YourSelectionOrNotEnough:
              'Няма достатъчно оставащи дни за избрания тип отпуск',
            TooManyFiles: 'Прекалено много прикачени файлове',
            MaximumFilesAllowed: 'Максимален брой прикачени файлове',
            DuplicateFilesSkipped: 'Дублираните файлове са пропуснати',
            SkippedFiles: 'Пропуснати файлове',
            FilesAdded: 'Файловете са добавени успешно',
            added: 'добавени',
          },
          LeaveTracker: {
            daysUsed: 'използвани дни',
            daysRemaining: 'оставащи дни',
            TotalDays: 'Общо дни',
            UsedDays: 'Използвани дни',
            RemainingDays: 'Оставащи дни',
          },

          weekdays: {
            Monday: 'Понеделник',
            Tuesday: 'Вторник',
            Wednesday: 'Сряда',
            Thursday: 'Четвъртък',
            Friday: 'Петък',
            Saturday: 'Събота',
            Sunday: 'Неделя',
            Mon: 'Пон',
            Tue: 'Вт',
            Wed: 'Ср',
            Thu: 'Чт',
            Fri: 'Пет',
            Sat: 'Съб',
            Sun: 'Нед',
          },
          MyDeparment: {
            Today: 'Днес',
            Employee: 'Служител',
            Summary: 'Обобщение',
            NoDataAvailable: 'Няма налични данни',
            allData: 'Всичко',
            workSchedule: 'Работен график',
            absence: 'Отсъствия',
            Error: 'Грешка',
            FailedFetch: 'Грешка при изтегляне на данните',
            Confirm: 'Потвърди',
            Cancel: 'Отказ',
            Clear: 'Изчисти',
            Delete: 'Изтрий',
            SaveAndSend: 'Запази и изпрати',
            Success: 'Успешно',
            WorkSaved: 'Работният график е запазен успешно',
            SaveCancelled: 'Запазването е отменено',
            SelectType: 'Избери тип',
            Minimize: 'Минимизирай',
            Maximize: 'Максимизирай',
            Hours: 'часа',
          },
          Approvals: {
            SearchEmployeeName: 'Търси по име на служител...',
            pendingApproval: 'Чакащо одобрение',
            Approved: 'Одобрено',
            Department: 'Отдел',
            EmployeeName: 'Име на служителя',
            LeaveDescription: 'Описание на отпуск',
            LeavePeriod: 'Период на отпуска',
            Duration: 'Брой',
            Status: 'Статус',
            Details: 'Детайли',
            Actions: 'Действия',
            Approve: 'Одобри',
            Reject: 'Отхвърли',
            Date: 'Дата',
            Type: 'Тип',
            Description: 'Описание',
            Attachments: 'Прикачи',
            NoAttachments: 'Няма прикачени документи',
            Time: 'Време',
            Hours: 'Часове',
            Close: 'Затвори',
            ConfirmAction: 'Потвърди действие',
            ConfirmReject: 'Сигурни ли сте, че искате да откажете този отпуск?',
            Cancel: 'Отказ',
            ConfirmRejectAction: 'Отхвърли',
            ConfirmApproveAction: 'Одобри',
            ConfirmApprove:
              'Сигурни ли сте, че истаке да одобрите този отпуск?',
            summary: 'Обобщение',
            details: 'Детайли',
            attachments: 'Прикачени документи',
            leaveRequest: 'Заявка за отсъствие',
            total: 'Общо',
            days: 'дни',
            day: 'ден',
            аpprovedBy: 'Одобрен от',
            Replacement: 'Заместник',
            Download: 'Изтегли',
            NoPendingApprovals: 'Няма чакащи одобрения',
            NoApprovedItems: 'Няма одобрени отпуска',
            approved: 'одобренa',
            rejected: 'отхвърленa',
            Page: 'Стр',
            of: 'от',
            Showing: 'Показване',
            AllApproved: 'Всички одобрени',
            AllDeleted: 'Всички изтрити',
            NoSearchResults: 'Няма намерени резултати',
          },
          CompanyManagement: {
            CompanyManagement: 'Управление на компанията',
            AddEmployee: 'Добави служител',
            AddDepartment: 'Добави отдел',
            ManageEmployees: 'Управление на персонала',
            ManageManagers: 'Управление на мениджърите',
            ManageDepartments: 'Управление на отдели',
            Allowances: 'Правила за отпуски',
            LeaveTypes: 'Видове отпуска',
            Holidays: 'Възможни празници',
            DataImport: 'Качване на данни',
            Integrations: 'Интеграции',
            Upgrade: 'Обновяване',
            Search: 'Търси',
            Calendars: 'Календари',
            Reports: 'Отчети',
            Cancel: 'Отказ',
            Company: 'Компания',
            Document: 'Документи',
            StartMenu: 'Начален екран',
            Test: 'Тест',
            Sign: 'Подпис',
            FileSystemEntry: 'Прикачени документи',
            Files: 'Прикачени файлове',
            Notice: 'Уведомление',
            WorkTypes: 'Работен график',
          },
          Session: {
            SessionExpired: 'Сесията е изтекла',
            SessionExpiredDesc: 'Вашата сесия е изтекла. Моля, влезте отново.',
            SessionExtended: 'Сесията е удължена',
            SessionExtendedDesc: 'Вашата сесия е удължена с още един час.',
            SessionExpiringSoon: 'Сесията изтича',
            YourSessionWillExpireIn: 'След',
            minutes: 'минути',
            ExtendSession: 'Удължете',
          },
          AddEmployee: {
            AddEmployee: 'Добави служител',
            FirstName: 'Име',
            MiddleName: 'Презиме',
            LastName: 'Фамилия',
            EmploymentStart: 'Дата на започване на работа',
            EmploymentEnd: 'Последен работен ден',
            PickADate: 'Избери дата',
            Position: 'Длъжност',
            Payment: 'Работно време',
            Email: 'Е-майл',
            Role: 'Роля',
            Roles: 'Роля',
            Department: 'Отдел',
            EmployeeCode: 'Служебен №',
            Employee: 'Служител',
            Approver: 'Одобряващ',
            Admin: 'Администратор',
            General: 'Общa информация',
            Organization: 'Организация ',
            Other: 'Друго',
            UnusedAllowanceDays: 'Неизползвани дни',
            PleaseSelectCompany: 'Изберете компания',
            SelectRole: 'Избери роля',
            WorkHours: 'Работни часове',
            WorkTime: 'Работно време',
            ListedAnnualLeaves: 'Отпуска',
            Standard: 'Стандартно',
            StandardOver: 'Стандартно и извънредно',
            ByHour: 'Почасово',
            TotalАmount: 'Общот брой',
            Days: 'дни',
            Creating: 'Създаване на служител ...',
            UserCreatedSuccessfully: 'Потребителят е създаден успешно!',
            Error: 'Грешка',
            ErrorEmail: 'Имейл адресът не е валиден.',
            ErrorOrganization: 'Избраната организация не е намерена',
            ErrorEmailAlreadyExists:
              'Потребителят с този имейл вече съществува.',
            ErrorEmployeeCode: 'Кодът на служителя вече съществува',
            ErrorFailed: 'Неуспешно създаване на потребител',
            ErrorCustomClaim: 'Неуспешно задаване на персонализирано искане',
            Success: 'Успешно',
            CurrentYear: 'Текуща година',
            TotalDays: 'Общо дни',
            UsedDays: 'Използвани дни',
            RemainingDays: 'Оставащи дни',
            AddPreviousYear: 'Добави отпуск от предишната година',
            RemoveYear: 'Премахни годината',
            AddAndInvite: 'Добави и покани',
            UserCreatedAndInvited: 'Потребителят е създаден и поканен успешно!',
            Processing: 'Обработка ...',
            Cancel: 'Отказ',
          },
          AddDeparment: {
            CreateNewDepartment: 'Създай нов отдел',
            DepartmentName: 'Име на отдел',
            DepartmentLocation: 'Местоположение',
            message: 'Моля, въведете името и местоположението на отдела.',
            Create: 'Създай',
            DepartmentAlreadyExists: 'Отделът вече съществува',
            ADepartmentWithName: 'Отдел с име',
            Andlocation: 'и местоположение',
            AlreadyExistsForThisCompany: 'вече съществуват за тази компания',
            DepartmentCreated: 'Отделът е създаден',
            Department: 'Отдел',
            CreatedSuccessfully: 'e създаден успешно',
            Error: 'Грешка',
            ErrorMessage: 'Възникна грешка при обработката на вашата заявка',
          },
          CreationStepsWizard: {
            Based:
              'Въз основа на държавата на вашата компания е избран следният шаблон:',
            MessageDeparments:
              'Моля, въведете вашите отдели, или ако желаете може да натисните бутона "Продължи" и ги въведете по-късно.',
            MessageEmployees:
              'Моля, въведете вашите служители, или ако желаете може да натисните бутона "Продължи" и ги въведете по-късно.',
          },
          ManageDepartments: {
            CreateNewDepartment: 'Създай нов отдел',
            DepartmentName: 'Име на отдел',
            DepartmentLocation: 'Място на отдел',
            message: 'Моля, въведете името и местоположението на отдела.',
            ManageDepartments: 'Управление на отдели',
            DepartmentAddedMessage: 'Отделът е добавен',
            SaveChanges: 'Запази промените',
            Name: 'Име',
            AddDepartment: 'Добави отдел',
            Approver: 'Одобряващ',
            Location: 'Място',
            Actions: 'Действия',
            NoDataAvailable: 'Няма налични данни',
            DepartmentDeleted: 'Отделът е изтрит',
            Create: 'Създай',
            Cancel: 'Отказ',
            Saving: 'Запазване ...',
            Delete: 'Изтрий',
            ConfirmDeletion: 'Потвърдете изтриването',
            ConfirmDeletionMessage:
              'Сигурни ли сте, че искате да изтриете този отдел?',
            ErrorMessageOne:
              'Грешка при изтегляне на данните. Моля, опитайте отново по-късно',
            ErrorFetch:
              'Грешка при изтегляне на данни. Моля, опитайте отново по-късно',
            ChangesSaved: 'Промените са запазени',
            ChangesSavedMessage: 'Всички промени са запазени успешно',
            Error: 'Грешка',
            ErrorMessageTwo:
              'Грешка при добавяне на отдела. Моля, опитайте отново по-късно.',
            ErrorMessageThree: 'Грешка при запазване на промените.',
            MissingInformation: 'Липсваща информация',
            DepartmentAdded: 'Отделът е добавен',
            DepartmentAddedМessage: 'Отделът е добавен успешно',
            DepartmentExists: 'Отделът вече съществува',
            DepartmentExistsMessage: 'Отделът вече съществува',
            DepartmentDeletedMessage: 'беше изтрит успешно.',
            DeletionFailed: 'Изтриване не е успешно',
            DeletionFailedMessage:
              'Не може да изтрие този отдел, тъй като има свързани данни. Първо изтрийте свързаните данни.',
            ApproversUpdated: 'Одобряващите са актуализирани',
            ApproversUpdatedMessage:
              'Одобряващите на отдела са актуализирани успешно',
            ErrorUpdatingApprovers:
              'Грешка при актуализиране на одобряващите. Моля, опитайте отново по-късно.',
            ErrorDeletingDepartment:
              'Грешка при изтриване на отдела. Моля, опитайте отново по-късно.',
          },
          ManageManagers: {
            ManageManagers: 'Управление на мениджърите',
            ManagerName: 'Име на мениджъра',
            ManagerDepartment: 'Отдели',
            ApprovalManager: 'Одобряващ мениджър',
            SelectApprovers: 'Избери одобряващи',
            SaveChanges: 'Запази промените',
            SuccessTitle: 'Успешно',
            Apply: 'Приложи',
            NoApproversFound: 'Няма налични одобряващи',
            successTitle: 'Успешно',
            ChangesSaved: 'Промените са запазени',
            SelectManagers: 'Избери мениджъри',
            EmployeesSelected: 'служители избрани',
            ApplyChanges: 'Приложи промените',
            Cancel: 'Отказ',
            Company: 'Компания',
          },
          Allowances: {
            Allowance: 'Правила за отпуски',
            Description: 'Описание',
            Policy: 'Допълнителна информация',
            Actions: 'Дейстия',
            NoDataAvailable: 'Няма данни',
            AllowancePolicy: 'Правила за отпуски',
            AllowanceName: 'Име на правило',
            AllowanceDescription: 'Описание',
            AnnualDays: 'Годишен брой дни',
            DaysPerYear: 'Дни на година',
            CarryOver: 'Прехвърляне',
            CarryOverNo: 'Без прехвърляне',
            MaximumCarryOver: 'Максимален брой дни за прехвърляне',
            Unused: 'Неизползваната дни да се пренася за следващата година',
            Days: 'дни',
            Months: 'месеца',
            NeverExpire: 'Никога не изтича',
            ExpiryUnit: 'Единица за изтичане',
            CarryOverExp: 'Прехвърлянето изтича след',
            Cancel: 'Откажи',
            Save: 'Запази',
            CarryOverUpTo: 'Може да се пренася до',
            AddAllowance: 'Добави правило',
            AddAllowancePolicy: 'Добави правило за отсъствия',
            EditAllowancePolicy: 'Редактирай правило за отсъствия',
            DaysForYear: 'Брой дни',
            AllowanceForMonth: 'Дни за месец',
            ErrorOne:
              'Задължително трябва да въведете име за правилото за отсъствия и дни',
            ErrorTwo: 'Дните за отсъствие трябва да са по вече от 0',
            ConfirmDelete: 'Потвърдете изтриването',
            ConfirmDeleteMessage:
              'Сигурни ли сте, че искате да изтриете правилото за отсъствия?',
            Delete: 'Изтрий',
          },
          ResetPassword: {
            title: 'Въведи парола',
            newPassword: 'Нова парола',
            confirmPassword: 'Потвърди парола',
            updatePassword: 'Обнови парола',
            success: 'Успешно',
            passwordUpdated: 'Паролата е обновена успешно',
            error: 'Грешка',
            invalidLink: 'Невалиден линк',
            pleaseRequestNew: 'Моля, поискайте нов линк за промяна на паролата',
            passwordTooShort: 'Паролата трябва да бъде поне 6 символа',
            passwordsDoNotMatch: 'Паролите не съвпадат',
            passwordRequired: 'Паролата е задължителна',
          },
          LeaveTypes: {
            Name: 'Име',
            Color: 'Цвят',
            Description: 'Описание',
            Actions: 'Действия',
            LeaveTypes: 'Видове отпуска',
            CodeAlreadyExists: 'Кодът вече съществува',
            AddLeaveType: 'Добави вид отпуска',
            EditLeaveType: 'Редактирай вид отпуска',
            DisplayColor: 'Цвят',
            DeductFromAllowance: 'Добавяне на правило',
            DoesNotDeduct: 'Не се изважда от правило',
            NoDataAvailable: 'Няма данни',
            Deduct: 'Приспадане от',
            CodeInUse: 'Не може да изтриете този код',
            CodeInUseDescription:
              'Този код се използва в отсъствията на служителите.',
            SelectedAllowance: 'Избрано правило',
            WorkSchedule: 'Работен график',
            is_hidden: 'Скрий',
            Code: 'Код',
            Type: 'Тип',
            Main: 'Основен екран',
            SelectACode: 'Избери код',
            EditCodes: 'Редактиране на кодове',
            ExistingCodes: 'Съществуващи кодове',
            AddCode: 'Добави код',
            Close: 'Затвори',
            Update: 'Обнови',
            SaveChanges: 'Запази промените',
            SaveCodes: 'Запази',
            UpdateCode: 'Обнови',
            DeleteConfirmation: 'Потвърждение за изтриване',
            DeleteConfirmationMessage:
              'Систе ли сигурен, че искате да изтриете данните?',
            Delete: 'Изтрий',
            Cancel: 'Отказ',
            UpdatedSuccessfully: 'Данните са обновени успешно',
            SelectTypes: 'Избери тип',
            Paid: 'Платен',
            Unpaid: 'Неплатен',
            Sick: 'Болничен',
            Work: 'Работен',
            AbsenceLeaves: 'Видове отсъствия',
            ErrorOne: 'Име и цвят са задължителни.',
            LeaveTypeUpdatedSuccessfully: 'Видът отпуск е обновен успешно',
            LeaveTypeAddedSuccessfully: 'Видът отпуск е добавен успешно',
            LeaveTypeDeleteSuccessfully: 'Видът отпуск е изтрит успешно',
            ErrorSaving: 'Грешка при запазване',
            ErrorDeleting: 'Грешка при изтриване',
            LeaveTypeMovedUpSuccessfully:
              'Вид отпуск е преместен нагоре успешно',
            LeaveTypeMovedDownSuccessfully:
              'Вид отпуск е преместен надолу успешно',
            ErrorMovingLeaveTypeUp: 'Грешка при преместване нагоре',
            ErrorMovingLeaveTypeDown: 'Грешка при преместване надолу',
            DuplicateNameError: 'Името вече съществува',
            LeaveTypeNameExists: 'Името вече съществува',
            Save: 'Запази',
            AutoApproval: 'Автоматично одобрение',
            DocRequired: 'Документ е задължителен',
            WorkTypes: 'Работен график',
            AddWorkType: 'Добави работен тип график',
            WorkScheduleTypes: 'Видове работен график',
            EditWorkType: 'Редактирай работен тип график',
            WorkTypeAddedSuccessfully: 'Работният тип график е добавен успешно',
            WorkTypeUpdatedSuccessfully:
              'Работният тип график е обновен успешно',
          },
          Reports: {
            Reports: 'Отчети',
            Form76: 'Форма 76',
            SelectDepartment: 'Избери отдел',
            AllDepartments: 'Всички отдели',
            Download: 'Изтегли данните',
            Error: 'Грешка',
            ErrorMessage:
              'Моля изберете месец и отдел преди изтегляне на данните',
            ErrorReport: 'Възникна грешка при генерирането на отчета',
            FailedToLoadCode: 'Неуспешно зареждане на данните',
            NotReady: 'Данните не са готови',
            CodeLoading: 'Данните се зареждат. Моля изчакайте.',
            SelectDate: 'Избери дата',
            SelectDateMessage: 'Моля, изберете дата, за да видите отчета.',
          },
          employeeBulkUpload: {
            title: 'Служители',
            description:
              'За да импортирате, моля изтеглете този Excel (.xlsx) шаблон, попълнете детайлите и го качете.',
            uploadButton: 'Качване чрез шаблон',
            uploading: 'Качване...',
            downloadTemplate: 'Изтегли шаблон',
            firstName: 'Име',
            middleName: 'Презиме',
            lastName: 'Фамилия',
            email: 'email',
            department: 'Отдел',
            employeeCode: 'Номер на служител',
            position: 'Позиция',
            workhour: 'Работно време',
            workhours: 'Работно време',
            startDate: 'Дата на започване',
            endDate: 'Дата на напускане',
            role: 'Роля',
            hasCustomAllowances: 'Ръчно въвеждена на квота',
            SelectFromList: 'Избери от списъка',
            selectRole: 'Избери роля',
            yes: 'ДА',
            no: 'НЕ',
            employee: 'Служител',
            approver: 'Одобрител',
            admin: 'Администратор',
            year: 'Година',
            type: 'Тип',
            total_days: 'Общ брой дни',
            totalDays: 'Общ брой дни',
            remaining_days: 'Останали дни',
            remainingDays: 'Останали дни',
            used_days: 'Използвани дни',
            usedDays: 'Използвани дни',
            id: 'ID',
            deploc: 'Местоположение на отдела',
            exampleFirstName: 'Име',
            exampleMiddleName: 'Презиме',
            exampleLastName: 'Фамилия',
            exampleDepartment: 'Избери отдел',
            exampleEmployeeCode: '1001',
            examplePosition: 'счетоводител',
            exampleWorkHour: '8',
            exampleStartDate: '2023-01-01',
            exampleEndDate: '',
            exampleRole: 'Избери роля',
            departmentId: 'ID',
            departmentLocation: 'Местоположение на отдела',
            invalidRole: 'Невалидна роля',
            invalidRoleMessage: 'Моля изберете валидна роля.',
            invalidDepartment: 'Невалиден отдел',
            invalidDepartmentMessage: 'Моля изберете валиден отдел.',
            invalidSelection: 'Невалиден избор',
            invalidSelectionMessage: 'Моля изберете валиден избор.',
            worksheetEmployees: 'Служители',
            worksheetAllowances: 'Отсъствия',
            worksheetDepartments: 'Отдели',
            sendEmailInvites: 'Изпрати покани по имейл',
          },
          allowancesCard: {
            title: 'Отсъствия',
            description:
              'За да импортирате, моля изтеглете този Excel (.xlsx) шаблон, попълнете детайлите и го качете.',
            uploadButton: 'Качване чрез шаблон',
            downloadButton: 'Изтегли шаблон',
            email: 'Email',
            leaveType: 'Вид отсъствие',
            leaveTypeDescription: 'Описание',
            startDate: 'Начална дата',
            endDate: 'Крайна дата',
            hours: 'Часове',
            exampleEmail: 'example@company.com',
            exampleLeaveType: 'Отпуск',
            exampleDescription: '',
            exampleStartDate: 'YYYY-MM-DD',
            exampleEndDate: 'YYYY-MM-DD',
            exampleHours: '8',
            emptyRow: 'Всички полета са празни',
            invalidEmail: 'Имейлът липсва или е невалиден',
            missingLeaveType: 'Липсва вид отсъствие',
            missingStartDate: 'Липсва начална дата',
            missingEndDate: 'Липсва крайна дата',
            missingHours: 'Липсват часове',
            invalidDateRange:
              'Крайната дата не може да бъде преди началната дата',
            invalidLeaveType:
              '{{type}} не съвпада с нито едно в данните за типовете отпуски',
            emailNotFound: 'Имейлът не е намерен в системата',
            dateOverlap:
              'Намерено е припокриване на дати със съществуващи отпуски: {{dates}}',
            uploading: 'Качване...',
          },
          DataImport: {
            NoData: 'Номер',
            NonData: 'Няма данни',
            Status: 'Статус',
            Reason: 'Причина',
            ImportStatus: 'Статус на импортиране',
            DataImport: 'Качане на данни',
          },
          ErrorBoundry: {
            Message: 'Възникна грешка, моля презаредете страницата.',
            Updating: 'Приложението се актуализира...',
            UpdateMessage:
              'Обновяваме приложението, за да заредим най-новата версия. Това ще отнеме само момент.',
            RetryNow: 'Опитайте отново',
          },
          Company: {
            Company: 'Компания',
            Name: 'Име',
            FirstDayOfWeek: 'Първи ден от седмицата',
            AddCompany: 'Добави компания',
            Actions: 'Действия',
            CompanyName: 'Има на компания',
            address: 'Адрес',
            Town: 'Град',
            Cancel: 'Откажи',
            Save: 'Запази',
          },
          Holidays: {
            Holidays: 'Празници',
            AddHoliday: 'Добави празник',
            Year: 'Година',
            Country: 'Държава',
            Language: 'Език',
            message: 'Моля, въведете годината, държавата и езикът на празника.',
            SelectYear: 'Избери година',
            SelectACountry: 'Избери държава',
            SelectAlanguage: 'Избери език',
            Date: 'Дата',
            Name: 'Име',
            AddToList: 'Добави в списъка',
            NewHoliday: 'Нов празник',
            HolidaysFor: 'Празници за',
            Location: 'Място',
            AssignedEmployees: 'Разпределени служители',
            NumberOfHolidays: 'Брой празници',
            NoDataAvailable: 'Няма налична информация',
            Actions: 'Действия',
            Summary: 'Oписание',
            Cancel: 'Откажи',
            Save: 'Запази',
          },
          EmployeesCard: {
            Employees: 'Служители',
            DownloadEmployeesData:
              'Изтегли данните за служителите',
            DownloadData: 'Изтегли данните',
            Downloading: 'Изтегляне на данни...',
            ReportDate: 'Дата на отчета',
            DepartmentID: 'Отдел',
            ID: 'ID',
            Name: 'Име',
            Email: 'Емайл',
            PersonnelNumber: 'Служебен номер',
            Role: 'Роля',
            StartDate: 'Дата на започване',
            YearsOfService: 'Прослужено време',
            ApproverID: 'ID на одобрителя',
            ApproverName: 'Име на одобрителя',
          },
          LeaveCard: {
            Leave: 'Отсъствия',
            DownloadLeaveData: 'Изтегли данни за отсъствия',
            DownloadData: 'Изтегли данни',
            Downloading: 'Изтегляне...',
            ReportDate: 'Дата на отчета',
            DepartmentID: 'Отдел',
            Name: 'Име',
            Email: 'Имейл',
            PersonnelNumber: 'Служебен номер',
            Role: 'Роля',
            StartDate: 'Начална дата',
            YearsOfService: 'Години стаж',
            Type: 'Тип',
            Status: 'Статус',
            EndDate: 'Крайна дата',
            Description: 'Описание',
            Hours: 'Часове',
            ApprovedBy: 'Одобрен от',
            Attachments: 'Прикачени файлове',
            status: {
              Approved: 'Одобрено',
              'Pending Approval': 'Изчакващо одобрение',
              Deleted: 'Изтрито',
            },
          },
          AllowanceCard: {
            Allowances: 'Квота отсъствия',
            DownloadAllowanceData:
              'Изтегли данните за служителите',
            DownloadData: 'Изтегли данните',
            Downloading: 'Изтегляне...', // Added missing key
            SelectDate: 'Избери дата',
            SelectYear: 'Избери година',
            ReportDate: 'Дата на отчета',
            AllowanceName: 'Надбавка',
            AllowanceDescription: 'Описание надбавка',
            CalendarStart: 'Начало на периода',
            CalendarEnd: 'Край на периода',
            AnnualLeave: 'Годишна отпуска',
            CarryOver: 'Прехвърляне',
            MaxCarryOver: 'Максимално прехвърляне',
            CarryOverExpires: 'Изтичане на прехвърляне',
            ExpiryUnit: 'Единица за изтичане',
            DepartmentID: 'Отдел',
            ID: 'ID',
            Name: 'Име',
            Email: 'Емайл',
            PhoneNumber: 'Работен номер',
            Role: 'Роля',
            StartDate: 'Дата на започване',
            YearsofService: 'Прослужено време',
            AccruedAllowance: 'Изработено време',
            TotalAllowance: 'Общо време',
            Used: 'Използвано',
            RemainingtoTake: 'Оставащо',
            CarriedfromLastYear: 'Прехвърлено от миналата година',
            Error: 'Грешка',
            FailedFetch: 'Неуспешно изтегляне на данни за отдела',
            PleaseSelect: 'Моля, изберете дата за отчет',
          },
          ManageEmployees: {
            ManageEmployees: 'Управление на персонала',
            Name: 'Име',
            MiddleName: 'Презиме',
            Edit: 'Редактирай',
            Email: 'Емайл',
            Role: 'Роля',
            Actions: 'Действия',
            EditUser: 'Редактирай служител',
            FullName: 'Пълно име',
            EmploymentStartDate: 'Начална дата на работа',
            EmploymentStartEnd: 'Крайна дата на работа',
            Employee: 'Служител',
            Approver: 'Одобряващ',
            Admin: 'Админ',
            EmployeeCode: 'Служебен №',
            DepartmentLocation: 'Отдел/Местоположение',
            Cancel: 'Откажи',
            NoDataAvailable: 'Няма налични данни',
            Delete: 'Изтрий',
            ConfirmDeleteMessage:
              'Сигурни ли сте, че искате да изтриете този служител?',
            ConfirmDelete: 'Потвърдете Изтриване',
            TypeDeleteToConfirm: 'Въведете "DELETE", за да потвърдите',
            General: 'Общa информация',
            Organization: 'Организация',
            Other: 'Друго',
            Department: 'Отдел',
            EmploymentStart: 'Дата на започване на работа',
            Roles: 'Роля',
            Position: 'Длъжност',
            EmploymentEnd: 'Последен работен ден',
            UpdateEmployee: 'Актуализиране данните за служител',
            Updating: 'Актуализиране...',
            UpdateUser: 'Актуализиране',
            WorkTime: 'Работно време',
            WorkHours: 'Работни часове',
            successTitle: 'Успех',
            resetPasswordEmailSent:
              'Информация за промяна на паролата е изпратена на потребител',
            errorTitle: 'Грешка',
            ListedAnnual: 'Изброени отпуски за година',
            TotalDays: 'Общо дни',
            UsedDays: 'Използвани дни',
            RemainingDays: 'Оставащи дни',
            InviteEmployee: 'Покани служител',
            EditEmployee: 'Редактирай служител',
            EnableEmployee: 'Активирай служител',
            DisableEmployee: 'Деактивирай служител',
            DeleteUser: 'Изтрий служител',
            AddEmployee: 'Добави служител',
            magicLinkSent: 'Емайл е изпратен на потребителя',
            FirstName: 'Име',
            LastName: 'Фамилия',
            Error: 'Грешка',
            FailedFetch: 'Грешка при изтегляне на данните',
            FailedUpdate: 'Грешка при обнованване на данните',
            FailedDelete: 'Грешка при изтриване на данните',
            Success: 'Успешно',
            UserUpdated: 'Данните са обновени успешно',
            UserDeleted: 'Данните са изтрити успешно',
            UserLocked: 'Потребителят е деактивиран успешно',
            UserUnlocked: 'Потребителят е активиран успешно',
            FailedToLock: 'Потребителят не е деактивиран',
            FailedToUnlock: 'Потребителят не е активиран',
            UnlockUser: 'Активирай служител',
            LockUser: 'Деактивирай служител',
            ConfirmLock: 'Потвърдете деактивирането',
            ConfirmLockMessage:
              'Сигурни ли сте, че искате да деактивирате този потребител?',
            LockUntilDate: 'Деактивирай от ',
            ConfirmUnlock: 'Потвърдете активирането',
            ConfirmUnlockMessage:
              'Сигурни ли сте, че искате да активирате този потребител?',
            GoTo: 'Отиди на',
            Warning: 'Внимание',
            PermanentDeleteWarning:
              'Тази операция е необратима. Всички данни, свързани с този служител, ще бъдат изтрити.',
            DeleteConfirmMessage:
              'Сигурни ли сте, че искате да изтриете този служител?',
            TypeEmailToConfirm: 'Въведете емайла на служителя за да потвърдите',
            Type: 'Въведете',
            ToConfirm: 'за да потвърдите',
            LoadingAllowances: 'Зареждане на данните за отсъствията ...',
            NoAllowancesFound: 'Няма намерени отсъствия',
            AdvancedFiltering: 'Разширено филтриране',
            SearchByName: 'Търсене по име',
            SearchByCode: 'Търсене по служебен номер',
            SearchByDepartment: 'Търсене по отдел',
            SearchByRole: 'Търсене по роля',
            ApplyFilters: 'Приложи филтри',
            ClearFilters: 'Изчисти филтри',
            All: 'Всички',
          },
          EditUser: {
            EditUser: 'Редактирай Потребител',
          },
          Legend: {
            CodeLegend: 'Легенда',
          },
          SetupData: {
            title: 'Задайте новата си парола',
            placeholder: 'Въведете новата си парола',
            confirmPlaceholder: 'Потвърдете паролата',
            passwordTooShort: 'Паролата трябва да е с дължина поне 6 символа',
            passwordsDontMatch: 'Паролите не съвпадат',
            resetPasswordButton: 'Потвърди',
            errorTitle: 'Грешка',
            invalidLinkDescription: 'Грешен линк',
            emailVerificationTitle: 'Потвърждаване на емайла',
            emailVerificationDescription:
              'Вашият имейл адрес бе потвърден успешно. Вече можете да влезете.',
            newPasswordLabel: 'Парола',
            confirmPasswordLabel: 'Потвърдете паролата',
          },
          AppUpdateNotification: {
            title: 'Налично обновление',
            description:
              'Нова версия на приложението е налична. Моля обновете страницата.',
            refresh: 'Обнови сега',
            refreshing: 'Обновява се...',
            later: 'По-късно',
          },
          SignUp: {
            Hello: 'Здравейте',
            NewPassword: 'Нова парола',
            ConfirmNewPassword: 'Потвърдете новата парола',
            CurrentPassword: 'Текуща парола',
            SuccessMessage: 'Паролата беше успешно променена',
            MessageOne: 'Моля, обновете паролата си.',
            MessageTwo:
              'Новата парола трябва да е дълга поне 8 знака и да съдържа поне една главна буква, една малка буква, едно число и един специален знак.',
            ErrorOneA: 'Паролата трябва да бъде поне',
            ErrorOneB: 'знака.',
            ErrorTwo: 'Паролата трябва да съдържа поне една главна буква.',
            ErrorThree: 'Паролата трябва да съдържа поне една малка буква.',
            ErrorFour: 'Паролата трябва да съдържа поне едно число.',
            ErrorFive: 'Паролата трябва да съдържа поне един специален знак.',
            ErrorSix: 'Паролите не съвпадат.',
            ErrorSeven: 'В момента няма влязъл потребител',
            VerifyEmail: 'Имейлът за потвърждение е изпратен.',
            VerifyError: 'Грешка при изпращане на имейл за потвърждение:',
          },
          roles: {
            Admin: 'Администатор',
            Approver: 'Одобряващ',
            Employee: 'Служител',
          },
          SetupCalendar: {
            LeaveYearCalendar: 'Календар',
            OptionOne: '1 Януари до 31 Декември',
            OptionTwo: '1 Април до 31 Март',
            OptionThree: 'По избор',
            Choose: 'Избери начална дата:',
            Message:
              'Календарът за годината задава времевата рамка за началото на календара и край. След края на този период, дните за този период се обновяват, ако има дни за пренасяне(неизползвани) от минали периоди се пренасят. Обикновенно този период съвпада с периода на финансовата година',
          },
          HomeDashboard: {
            Next: 'Следващите 7 дни',
            NextSchedule: 'Моя график за следващите 7 дни',
            Date: 'Дата',
            Type: 'Тип',
            Period: 'Период',
            Amount: 'Дни',
            Status: 'Статус',
            day: 'ден',
            days: 'дни',
            NoEvent: 'Няма събитие',
            Approved: 'Одобрено',
            PendingApproval: 'Чакащо одобрение',
            Work: 'Работен ден',
            Notice: 'Уведомление',
            NoticeMessage: 'платен годишен отпуск за',
            DownloadError: 'Грешка при изтегляне',
          },
          Footer: {
            PrivacyPolicy: 'Политика за защита на личните данни',
            TermsOfService: 'Условия за ползване',
            Copyright: 'Всички права запазени',
          },
        },
      },
    },
  });

export default i18n;
